import React, { useMemo } from 'react'
import Card from './components/Card'
import { adjustPosition, getRandomIntInclusive } from './components/utils'
import Chips from './components/Chips'
import useWindowSize from '../../hooks/useWindowSize'

const Table = ({ containerWidth = 950 }) => {
  const { width: screenWidth } = useWindowSize()

  const calculatedWidth = containerWidth / 3
  const width = Math.min(calculatedWidth, screenWidth-140)
  const height = width * 1.55
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 322 499"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.11468 145.184C7.9191 63.9257 82.8636 0.0715942 161.235 0.0715942C239.606 0.0715942 314.55 63.9257 318.355 145.184L321.776 328.994C326.089 421.134 250.102 498.291 161.235 498.291C72.3677 498.291 -3.62023 421.134 0.693696 328.994L4.11468 145.184Z"
        fill="#282C3B"
      />
      <g filter="url(#filter0_i_1831_21890)">
        <path
          d="M19.6903 155.209C21.0544 78.0109 84.0249 16.1432 161.235 16.1432C238.445 16.1432 301.416 78.0109 302.78 155.209L305.956 334.92C307.385 415.847 242.175 482.22 161.235 482.22C80.2954 482.22 15.0849 415.847 16.5149 334.92L19.6903 155.209Z"
          fill="#313647"
        />
      </g>
      <defs>
        <filter
          id="filter0_i_1831_21890"
          x="16.4922"
          y="16.1432"
          width="289.486"
          height="466.077"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1831_21890"
          />
        </filter>
      </defs>
    </svg>
  )
}

const TableView = ({
  hero,
  hand,
  opponent,
  opponentAction,
  containerWidth,
  playersBets,
}) => {
  const positionsConfig = {
    SB: {
      bottom: 0,
      left: '50%',
      transform: 'translateX(-50%) translateY(50%)',
      chipTop: -75,
      chipRight: 40,
    },
    BB: {
      bottom: '20%',
      left: 0,
      transform: 'translateX(-50%)',
      chipRight: -65,
      chipTop: 0,
    },
    UTG: {
      top: '45%',
      left: 0,
      transform: 'translateX(-50%)',
      chipRight: -65,
      chipTop: 0,
    },
    'UTG+1': {
      top: '20%',
      left: 0,
      transform: 'translateX(-50%)',
      chipRight: -65,
      chipTop: 0,
    },

    'UTG+2': {
      top: 0,
      left: '50%',
      transform: 'translateX(-50%) translateY(-50%)',
      chipLeft: 45,
      chipBottom: -45,
    },

    'UTG+3': {
      top: '20%',
      right: 0,
      transform: 'translateX(50%)',
      chipLeft: -55,
      chipTop: 0,
    },
    CO: {
      top: '45%',
      right: 0,
      transform: 'translateX(50%)',
      chipLeft: -55,
      chipTop: 0,
    },
    BTN: {
      bottom: '20%',
      right: 0,
      transform: 'translateX(50%)',
      chipLeft: -55,
      chipTop: 0,
    },
  }

  const suits = ['c', 's', 'd', 'h']

  const suited = parseInt(hand[0]) > parseInt(hand[1])

  const firstSuitIndex = useMemo(() => getRandomIntInclusive(0, 3), [])
  const cardsLeft = [
    ...suits.slice(0, firstSuitIndex),
    ...suits.slice(firstSuitIndex + 1, suits.length),
  ]
  const secondSuitIndex = useMemo(() => getRandomIntInclusive(0, 2), [])
  const handSuits = [suits[firstSuitIndex], cardsLeft[secondSuitIndex]]
  if (suited) {
    handSuits[1] = handSuits[0]
  }

  return (
    <div className="ClearTheCharts__table">
      {Object.entries(positionsConfig).map(([position, config]) => {
        const isHero = adjustPosition(position) === adjustPosition(hero)
        const isOpponent = adjustPosition(position) === adjustPosition(opponent)
        let background = 'linear-gradient(180deg, #565D74 0%, #282C3B 100%)'
        if (isHero)
          background = 'linear-gradient(180deg, #F3AE1E 0%, #E27F0B 100%)'
        if (isOpponent) background = 'white'
        return (
          <div style={{ position: 'absolute', ...config }}>
            {isOpponent && !!opponentAction && (
              <div
                style={{
                  position: 'absolute',
                  bottom: 0,
                  transform: 'translateY(50%) translateX(-50%)',
                  backgroundColor: '#0085ff',
                  marginLeft: '50%',
                  zIndex: 4,
                  padding: '2px 4px',
                  borderRadius: 4,
                }}
              >
                <div
                  style={{
                    textAlign: 'center',
                    fontSize: '10px',
                    color: 'white',
                    textWrap: 'nowrap',
                    textTransform: 'capitalize'
                  }}
                >
                  {opponentAction.toLowerCase().replace("vs", '')}
                </div>
              </div>
            )}

            {isHero && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  transform: 'translateY(-90%) translateX(20%)',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  zIndex: 2,
                }}
              >
                <Card hand={hand} suit={handSuits[0]} index={0} />
                <Card hand={hand} suit={handSuits[1]} index={1} />
              </div>
            )}
            <Chips
              config={config}
              playersBets={playersBets}
              position={adjustPosition(position)}
              oppPosition={opponent}
            />
            <div
              style={{
                minWidth: '100px',
                zIndex: 3,
                position: 'relative',
                background,
                borderRadius: '16px',
                borderStyle: 'solid',
                borderColor: 'orange',
                borderWidth: isOpponent ? 3 : 0,
                boxShadow: isHero
                  ? '0px 0px 8px rgba(243, 171, 30, 0.5)'
                  : 'none',
              }}
            >
              <div
                style={{
                  textAlign: 'center',
                  fontSize: '17px',
                  color: isOpponent ? 'black' : 'white',
                  padding: '9px 18px',
                }}
              >
                {adjustPosition(position)}
              </div>
            </div>
          </div>
        )
      })}
      <Table containerWidth={containerWidth} />
    </div>
  )
}

export default TableView
